import React from "react";

const BulletList = ({ items }) => {

	const renderItem = (item, index) => {
		switch (item.type) {
			case 'text':
				return <li key={index}><span>{item.value}</span></li>;
			case 'bullet-list':
				return (
					<ul key={index} className="mb-0">
						{item.values.map((child, childIndex) => renderItem(child, childIndex))}
					</ul>
				);
			default:
				return null;
		}
	};

	return (
		<ul className="mb-0">
			{items.map((item, index) => renderItem(item, index))}
		</ul>
	);
};

export default BulletList;